import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Sparkles, User, Crown, Shield, Loader2 } from "lucide-react";

const ROLE_META = {
  user: { icon: User, label: "Standart Oyuncu", tone: "primary" },
  owner: { icon: Crown, label: "Oda Sahibi", tone: "accent" },
  admin: { icon: Shield, label: "Yönetici", tone: "destructive" },
};

/**
 * DemoPanel — landing/login sayfalarında görünen üç-tık demo giriş paneli.
 * Sadece backend DEMO_ENABLED=true olduğunda render edilir.
 */
export default function DemoPanel() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [info, setInfo] = useState(null);
  const [loadingRole, setLoadingRole] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/demo-info");
        if (data.enabled) setInfo(data);
      } catch (_) {}
    })();
  }, []);

  if (!info || !info.enabled) return null;

  const enter = async (role) => {
    setLoadingRole(role);
    try {
      const { data } = await api.post("/auth/demo-login", { role });
      setUser(data.user);
      toast.success(`Demo modu — ${data.user.display_name} olarak giriş yapıldı`);
      nav("/");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setLoadingRole(null);
    }
  };

  return (
    <div className="rounded-3xl border-2 border-dashed border-accent/50 bg-accent/10 p-4 space-y-3" data-testid="demo-panel">
      <div className="flex items-center gap-2">
        <div className="h-8 w-8 rounded-full gold-gradient flex items-center justify-center">
          <Sparkles className="h-4 w-4 text-primary" />
        </div>
        <div>
          <p className="font-display font-bold text-sm">Kayıt olmadan hemen dene</p>
          <p className="text-[11px] text-muted-foreground">Demo hesabıyla tek dokunuşta gir</p>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {info.accounts.map((acc) => {
          const meta = ROLE_META[acc.role] || ROLE_META.user;
          const Icon = meta.icon;
          const isLoading = loadingRole === acc.role;
          return (
            <button
              key={acc.role}
              onClick={() => enter(acc.role)}
              disabled={!!loadingRole}
              data-testid={`demo-${acc.role}`}
              className="rounded-2xl bg-card border border-border hover:border-primary/40 hover:bg-primary/5 transition-colors p-3 flex flex-col items-center gap-1.5 active:scale-[0.98] disabled:opacity-60"
            >
              <div className="h-9 w-9 rounded-full bg-primary/10 flex items-center justify-center text-primary">
                {isLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Icon className="h-4 w-4" />}
              </div>
              <span className="font-semibold text-xs text-center">{meta.label}</span>
              <span className="text-[10px] text-muted-foreground text-center leading-tight">@{acc.username}</span>
            </button>
          );
        })}
      </div>
      <p className="text-[10px] text-muted-foreground text-center pt-1">
        Şifre: <span className="font-mono font-semibold">okey1234</span> · e-posta ile de giriş yapılabilir
      </p>
    </div>
  );
}
